import {
  callApi
} from "./Api";
import { actionCreator } from './helpers'

export const GET_CLIENT_BUSINESS_TOTAL = 'GET_CLIENT_BUSINESS_TOTAL';
export const CLIENT_BUSINESS_SEARCH = 'CLIENT_BUSINESS_SEARCH';
export const ALL_SEARCH = 'ALL_SEARCH';
export const USERS_SEARCH = 'USERS_SEARCH';
export const USERS_SEARCH_ALL_RESULT = "USERS_SEARCH_ALL_RESULT";
export const ALL_USERS_SEARCH = 'ALL_USERS_SEARCH';
export const SEARCH_CLIENTS_BY_KEYWORD = 'SEARCH_CLIENTS_BY_KEYWORD'
export const CLEAR_USERS_SEARCH = 'CLEAR_USERS_SEARCH';
export const clearUsersSearch = actionCreator(CLEAR_USERS_SEARCH)

export const getClientBusinessTotal = () => (dispatch, getState) => {
  const url = 'clients/stats';
  callApi(dispatch, getState, GET_CLIENT_BUSINESS_TOTAL, url);
}

export const clientBusinessSearch = (obj) => (dispatch, getState) => {
  const url = 'clients/stats/details/search';
  callApi(dispatch, getState, CLIENT_BUSINESS_SEARCH, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}

export const getAllSearch = (obj) => (dispatch, getState) => {
  const url = 'clients/stats/details/search';
  callApi(dispatch, getState, ALL_SEARCH, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}
export const usersSearch = (obj) => (dispatch, getState) => {
  const url = 'clients/stats/client/users';
  callApi(dispatch, getState, USERS_SEARCH, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}
export const usersSearchAll = (obj) => (dispatch, getState) => {
  const url = 'clients/stats/client/users';
  callApi(dispatch, getState, USERS_SEARCH_ALL_RESULT, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}
export const getAllUsersSearch = (obj) => (dispatch, getState) => {
  const url = 'clients/stats/client/users';
  callApi(dispatch, getState, ALL_USERS_SEARCH, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}

export const searchClientsWithKeyword = (keyword) => {
	const url = `clients/client-ids`;
	return (dispatch, getState) => {
		callApi(dispatch, getState, SEARCH_CLIENTS_BY_KEYWORD, url, {
			method: 'POST',
			body: JSON.stringify({keyword: keyword})
		});
	}
}



// WEBPACK FOOTER //
// ./src/actions/ClientBusinessInfoAndUser.js